import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
// WICHTIG: Hier wird FaLinkedin importiert
import { FaGithub, FaLinkedin } from 'react-icons/fa'; 
import '../styles/Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);

  const menuVariants = {
    hidden: { y: '-100%' },
    visible: {
      y: 0,
      transition: { 
        duration: 0.5, 
        ease: [0.22, 1, 0.36, 1],
        staggerChildren: 0.1,
        when: "beforeChildren",
      } 
    },
    exit: {
        y: '-100%',
        transition: { duration: 0.4, ease: [0.6, 0.05, -0.01, 0.9] }
    }
  };

  const linkVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };
  
  const socialVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <nav className="navbar container">
        <Link to="/" className="logo" onClick={closeMenu}>TG-Webhosting</Link>
        
        <ul className="nav-links-desktop">
          <li><a href="/#leistungen">Leistungen</a></li>
          <li><a href="/#portfolio">Portfolio</a></li>
          <li><Link to="/ueber-mich">Über Mich</Link></li>
          <li><a href="/#kontakt" className="cta-button" style={{padding: '0.5rem 1.5rem'}}>Kontakt</a></li>
        </ul>

        <button 
          className={`hamburger-button ${isMenuOpen ? 'active' : ''}`} 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Menü öffnen/schließen"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <AnimatePresence>
        {isMenuOpen && (
          <motion.ul 
            className="nav-links-mobile"
            variants={menuVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <motion.li variants={linkVariants}><a href="/#leistungen" onClick={closeMenu}>Leistungen</a></motion.li>
            <motion.li variants={linkVariants}><a href="/#portfolio" onClick={closeMenu}>Portfolio</a></motion.li>
            <motion.li variants={linkVariants}><Link to="/ueber-mich" onClick={closeMenu}>Über Mich</Link></motion.li>
            <motion.li variants={linkVariants}><a href="/#kontakt" className="cta-button" onClick={closeMenu}>Kontakt</a></motion.li>
            
            <motion.div className="mobile-socials" variants={socialVariants}>
                <motion.a href="https://github.com/PMTobi" target="_blank" rel="noopener noreferrer" variants={linkVariants}><FaGithub /></motion.a>
                <motion.a href="https://www.linkedin.com/in/tobias-grimm-004009334/" target="_blank" rel="noopener noreferrer" variants={linkVariants}><FaLinkedin /></motion.a>
            </motion.div>
          </motion.ul>
        )}
        </AnimatePresence>
      </nav>
    </header>
  );
};

export default Header;